import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Company from '../views/Company.vue'
import Kanban from '../views/Kanban.vue'
import Admin from '../views/Admin.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    children:[{
        path:'/hello',
        component:()=>import('../components/Hello.vue')
    },{
        path:'/cncKanban',
        component:()=>import('../components/CNCKanban.vue')
    },{
        path:'/productionKanban',
        component:()=>import('../components/ProductionKanban.vue')
    },{
        path:'/moldOrder',
        component:()=>import('../components/MoldOrder.vue')
    },{
        path:'/moldBOM',
        component:()=>import('../components/MoldBOM.vue')
    },{
        path:'/process',
        component:()=>import('../components/Process.vue')
    },{
        path:'/productionSite',
        component:()=>import('../components/ProductionSite.vue')
    },{
        path:'/assembly',
        component:()=>import('../components/Assembly.vue')
    },{
        path:'/polish',
        component:()=>import('../components/Polish.vue')
    },{
        path:'/moldTest',
        component:()=>import('../components/MoldTest.vue')
    },{
        path:'/moldRepair',
        component:()=>import('../components/MoldRepair.vue')
    },{
        path:'/warehouse',
        component:()=>import('../components/Warehouse.vue')
    },{
        path:'/companyInfo',
        component:()=>import('../components/CompanyInfo.vue')
    },{
        path:'/workSchedule',
        component:()=>import('../components/WorkSchedule.vue')
    },{
        path:'/department',
        component:()=>import('../components/Department.vue')
    },{
        path:'/employee',
        component:()=>import('../components/Employee.vue')
    },{
        path:'/role',
        component:()=>import('../components/Role.vue')
    },{
        path:'/bomBaseInfo',
        component:()=>import('../components/BOMBaseInfo.vue')
    },{
        path:'/customerBase',
        component:()=>import('../components/CustomerBase.vue')
    },{
        path:'/cutterBase',
        component:()=>import('../components/CutterBase.vue')
    },{
        path:'/warehouse',
        component:()=>import('../components/Warehouse.vue')
    },{
        path:'/equipmentManage',
        component:()=>import('../components/EquipmentManage.vue')
    },{
        path:'/operationLog',
        component:()=>import('../components/OperationLog.vue')
    },{
        path:'/smartCabinet',
        component:()=>import('../components/SmartCabinet.vue')
    },{
        path:'/accessLog',
        component:()=>import('../components/AccessLog.vue')
    }]
}, {
    path: '/Login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import( /* webpackChunkName: "about" */ '../views/Login.vue'),
    meta: {
        title: '极光智模-登录'
    }
}, {
    path: '/Company',
    name: 'Company',
    component: Company
}, {
    path: '/kb',
    name: 'Kanban',
    component: Kanban
},{
    path: '/admin',
    name: 'Admin',
    component: Admin,
    children:[{
        path:'hello',
        component:()=>import('../components/Hello.vue'),
        meta: {
            title: '极光智模-开发运营系统'
        },
    },{
        path:'tenantAdmin',
        component:()=>import('../components/TenantAdmin.vue')
    },{
        path:'userAdmin',
        component:()=>import('../components/UserAdmin.vue')
    }]
}]

const router = new VueRouter({
    mode: 'hash',
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router